import React from 'react';
import {useTranslation} from "react-i18next";

type HSCodeProps = {
    hsCode: string | null
}

const HSCode: React.FC<HSCodeProps> = ({
                                               hsCode
                                           }) => {
    const {t} = useTranslation();

    return (
        <>
            <label className={'hs-code-label'}>
                {t('offer.form.hs-code')}
            </label>
            <span className={'details-box-item-field-value hs-code-value'}>
                {hsCode !== null && hsCode !== ''
                    ? <>{hsCode}</>
                    : <>{t("shared.labels.no-data")}</>
                }
            </span>
        </>
    );
};

export default HSCode;